export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-button/index.js